(ns minorodata.app.handlers
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))


(def dispatch re-frame/dispatch)
(def dispatch-sync re-frame/dispatch-sync)
(def reg-fx re-frame/reg-fx)
(def reg-cofx re-frame/reg-cofx)
(def inject-cofx re-frame/inject-cofx)


(def standard-interceptors
  [re-frame/trim-v])


(defn wrap-fx-handler [handler-fn]
  (fn [& [_ event :as args]]
    (try
      (apply handler-fn args)
      (catch js/Error error
        {:dispatch [:app/event-error error event]}))))


(defn wrap-db-handler [handler-fn]
  (fn [& [db event :as args]]
    (try
      (apply handler-fn args)
      (catch js/Error error
        (dispatch [:app/event-error error event])
        ;; Return prev db state to not break the UI
        db))))


(defn wrap-ds-handler [handler-fn]
  (fn [& [_ event :as args]]
    (try
      (apply handler-fn args)
      (catch js/Error error
        (dispatch [:app/event-error error event])
        ;; No transactions should be applied
        nil))))


(defn reg-event-fx
  ([id handler-fn]
   (re-frame/reg-event-fx
     id
     standard-interceptors
     (wrap-fx-handler handler-fn)))

  ([id interceptors handler-fn]
   (re-frame/reg-event-fx
     id
     [standard-interceptors interceptors]
     (wrap-fx-handler handler-fn))))


(defn reg-event-db
  ([id handler-fn]
   (re-frame/reg-event-db
     id
     standard-interceptors
     (wrap-db-handler handler-fn)))

  ([id interceptors handler-fn]
   (re-frame/reg-event-db
     id
     [standard-interceptors interceptors]
     (wrap-db-handler handler-fn))))


(defn reg-event-ds
  ([id handler-fn]
   (re-posh/reg-event-ds
     id
     standard-interceptors
     (wrap-ds-handler handler-fn)))

  ([id interceptors handler-fn]
   (re-posh/reg-event-ds
     id
     [standard-interceptors interceptors]
     (wrap-ds-handler handler-fn))))
